export const TwoFactorAuthenticationHeader = 'x-two-factor-authentication';
